import { useState } from 'react';

const useRefreshComponent = () => {
    const [, setRefresh] = useState(Math.random());

    const refresh = () => {
        setRefresh(Math.random());
    };

    return refresh;
};

export { useRefreshComponent };
